import React from "react"
import { Box, Button as ChakraButton, Flex } from "@chakra-ui/react"
import { IButtonProps } from "./ButtonTypes"

const Button: React.FC<IButtonProps> = ({
  text,
  onClick,
  variant = "solid",
  isDisabled = false,
  isLoading = false,
  leftIcon,
  leftImg,
  smallSpacing,
  styles = {},
  type,
  ...rest
}) => {
  return (
    <ChakraButton
      onClick={onClick}
      disabled={isDisabled}
      variant={variant}
      isLoading={isLoading}
      loadingText={text}
      {...rest}
      {...styles}
    >
      <Flex justifyContent="space-between" alignItems="center">
        {leftIcon && <Box mr={smallSpacing ? "8px" : "18px"}>{leftIcon}</Box>}
        {leftImg && (
          <Box className="btn-icon" mr={smallSpacing ? "8px" : "18px"}>
            <img src={leftImg} />
          </Box>
        )}
        {text}
      </Flex>
    </ChakraButton>
  )
}

export default Button
